import { Component, Input } from '@angular/core';
import { Company } from '../../models/company.model';
import { ButtonComponent } from '@lx/shared/ui/button';
import { DialogModule } from 'primeng/dialog';
import { LowerCasePipe, NgClass } from '@angular/common';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-price-lists-popup',
  imports: [ButtonComponent, DialogModule, NgClass, LowerCasePipe],
  templateUrl: './price-lists-popup.component.html',
  styleUrls: ['./price-lists-popup.component.scss'],
})
export class PriceListsPopupComponent {
  @Input() title = '';
  @Input() company: Company | undefined;

  dialog = false;

  showDialog() {
    this.dialog = true;
  }
}
